<template>
<div class="map-container">
    <input type="text" v-model="searchText" ref="autocompleteInput" class="input" placeholder="Search for a location...">

    <div ref="map" class="map"></div>
    <div class="location-info">
        <div v-if="state.latitude !== null && state.longitude !== null">
            <strong>Latitude:</strong> {{ state.latitude }}
        </div>
        <div v-if="state.latitude !== null && state.longitude !== null">
            <strong>Longitude:</strong> {{ state.longitude }}
        </div>
    </div>

</div>
</template>

<script>
export default {
    name: 'Maps',
    props: {
        latitude: Number,
        longitude: Number
    },

    data() {
        return {
            state: {
                latitude: null,
                longitude: null,
            },
            searchText: '',

            map: null,
            marker: null
        };
    },
    mounted() {
        this.loadGoogleMapsScript().then(() => {
            this.initAutocomplete();
        });
    },
    methods: {
        loadGoogleMapsScript() {
            return new Promise((resolve, reject) => {
                const script = document.createElement('script');
                script.src = `https://maps.googleapis.com/maps/api/js?key=............&libraries=places`;
                script.async = true;
                script.defer = true;
                script.onload = resolve;
                script.onerror = reject;
                document.head.appendChild(script);
            });
        },
        initAutocomplete() {
            const autocomplete = new google.maps.places.Autocomplete(this.$refs.autocompleteInput);
            autocomplete.addListener('place_changed', () => {
                const place = autocomplete.getPlace();
                if (!place.geometry || !place.geometry.location) {
                    return;
                }
                this.state.latitude = place.geometry.location.lat();
                this.state.longitude = place.geometry.location.lng();
                this.showLocationOnMap(place.geometry.location);
            });

            this.map = new google.maps.Map(this.$refs.map, {
                center: {
                    lat: 13.733689480426454,
                    lng: 100.5254602432251
                },
                zoom: 15
            });

            this.map.addListener('click', (event) => {
                this.state.latitude = event.latLng.lat();
                this.state.longitude = event.latLng.lng();
                this.showLocationOnMap(event.latLng);
            });
        },
        showLocationOnMap(location) {
            if (!this.map) {
                return;
            }

            if (!this.marker) {
                this.marker = new google.maps.Marker({
                    position: location,
                    map: this.map
                });
            } else {
                this.marker.setPosition(location);
            }

            this.map.setCenter(location);
        },
        handleLocationChange(newLocation) {
            // Emit an event to notify the parent component of the new location
            this.$emit('locationChanged', newLocation);
        }
    }

};
</script>

<style>
.map-container {
    width: 100%;
}

.input {
    width: 100%;
    padding: 10px;
    font-size: 16px;
    margin-bottom: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-sizing: border-box;
    /* Ensures padding and border are included in the width */
    transition: border-color 0.3s ease;
    /* Smooth transition for border color change */
}

/* Hover and Focus Styles */
.input:hover,
.input:focus {
    border-color: #66afe9;
    /* Change border color on hover/focus */
    outline: none;
    /* Remove default focus outline */
}

.map {
    height: 400px;
    margin-bottom: 20px;
}

.location-info {
    background-color: #f9f9f9;
    padding: 10px;
    border-radius: 5px;
}

.location-info div {
    margin-bottom: 5px;
}
</style>
